import { PackageOpen } from 'lucide-react';
import {
  NACHLIEFERUNG_BESTELLUNG,
  NACHLIEFERUNG_POSITION,
  type NachlieferungArt
} from '@/lib/nachlieferung';

/**
 * Die Marke der Nachlieferung (E52) — „wird nachgeliefert" an der
 * Position, „Nachlieferung offen" an der Bestellung. Gold wie alles, was
 * noch Arbeit ist: Hier steht ein Versprechen an die Kundin aus.
 */
export function NachlieferungMarke({
  art,
  ebene
}: {
  art: NachlieferungArt;
  ebene: 'position' | 'bestellung';
}) {
  const text = ebene === 'position' ? NACHLIEFERUNG_POSITION[art] : NACHLIEFERUNG_BESTELLUNG[art];
  return (
    <span
      data-testid="nachlieferung-marke"
      className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded bg-gold-soft px-1.5 py-0.5 text-xs text-gold-dark"
      title={
        art === 'versand'
          ? 'Eine Teilsendung ist raus; dieser Rest wird portofrei nachgeliefert.'
          : 'Ein Teil wurde mitgegeben; der Rest wird später abgeholt.'
      }
    >
      <PackageOpen aria-hidden className="h-3 w-3" />
      {text}
    </span>
  );
}
